export enum StatusEnum {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  INACTIVE = "INACTIVE",
}

export enum StatusAccessREquest {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
}

export enum StatusRequest {
  REQUESTED = "REQUESTED",
  EXPIRED = "EXPIRED", 
  AWAITING = "AWAITING",    
}
